export const getRadioButtonBorderColor = (isActive, isDisabled) => {
  if (isActive && !isDisabled) {
    return 'primary';
  }
  if (!isActive && !isDisabled) {
    return 'grayText';
  }
  if (isActive && isDisabled) {
    return 'grayText';
  }
  return 'grayText';
};

export const getRadioButtonBackgroundColor = (isActive, isDisabled) => {
  if (!isActive && isDisabled) {
    return 'lightGray';
  }
  return 'white';
};
